<template>
  <m-base>
    <b-container class="m-layout-content" :fluid="true">
      <b-row style="margin-right: 0;margin-top: 16px">
        <b-col class="title header-title">
          <h1 style="margin-left: 16px">Videos</h1>
        </b-col>
      </b-row>
      <b-row style="margin-right: 0">
        <b-col style="padding-right: 0">
          <div class="box">
            <div class="the-content">
              <div>
                <div class="card" style="background-color: #eee !important; border: none;">
                  <div class="m-tabs">
                    <b-link class = "m-tab"
                            v-for = "(item,index) in categories"
                            :key = "item.categoryName"
                            :class = "{'m-tab-active': selectedIndex === index}"
                            @click="changeIndex(item, index)" >
                      {{item.categoryName}}
                    </b-link>

                  </div>
                  <div style="background-color: #fff;border: 1px solid rgba(0, 0, 0, 0.125);border-radius: .25rem;border-top: none;">
                    <b-row cass="geo-box">
                      <b-col>
                        <div style="height: 600px; padding: 25px;">
                          <iframe :src="currentVideoUrl" frameborder="0" allowfullscreen="allowfullscreen" class="iframe-embed"style="width: 100%;height: 100%;opacity:1;visibility: visible" ></iframe>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>

              </div>
            </div>
            <div class="the-slide" style="height: 642px;">
              <div class="box" style="width: 100%;" >
                <div style="width: 100%;">
                  <h2>My Videos</h2>
                  <div style="height: 580px; overflow-y: auto">
                  <div class="m-slide-section"
                       v-for="(item, index) in currentVideoList"
                       :class = "{'m-slide-section-active': selectedVideoIndex === index}"
                       @click="showVideo(item.videoUrl, index)" >
                    <div style="float:left;">
                      <img :src="require('@/assets/images/VideoMarketing.jpg')" style="width: 120px;">
                    </div>
                    <div style="float:left; margin: 25px;">
                      <h4>{{item.videoName}}</h4>
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </m-base>
</template>

<script>
  import MBase from '@/components/layouts/MBase'
  export default {
    components: {
      MBase
    },
    name: 'Videos',
    computed: {
      categories () {
        return this.$store.state.user.UserVideos
      },
      currentVideoUrl: {
        get: function () {
          if (this.videoUrl !== '') {
            return this.videoUrl
          } else {
            if (this.$store.state.user.UserVideos.length > 0) {
              return this.$store.state.user.UserVideos[0].videos[0].videoUrl
            } else {
              return this.videoUrl
            }
          }
        },
        set: function (newValue) {
          this.videoUrl = newValue
        }
      },
      currentVideoList: {
        get: function () {
          if (this.videoList.length > 0) {
            return this.videoList
          } else {
            if (this.$store.state.user.UserVideos.length > 0) {
              return this.$store.state.user.UserVideos[0].videos
            } else {
              return this.videoList
            }
          }
        },
        set: function (newValue) {
          this.videoList = newValue
        }
      }
    },
    methods: {
      changeIndex: function (item, index) {
        this.selectedIndex = index
        this.currentVideoUrl = item.videos[0].videoUrl
        this.currentVideoList = item.videos
        this.selectedVideoIndex = 0
      },
      showVideo: function (url, index) {
        this.currentVideoUrl = url
        this.selectedVideoIndex = index
      }
    },
    data: function () {
      return {
        selectedIndex: 0,
        selectedVideoIndex: 0,
        videoUrl: '',
        videoList: []
      }
    },
    beforeRouteEnter: (to, from, next) => {
      next(vm => {
        if (vm.$store.state.user.ShowVideos === false) {
          next({name: 'landing'})
        } else {
          next()
        }
      })
    }
  }
</script>

<style scoped lang="scss">
  .sub-title {
    color: $color-text-grey;
    font-size: $size-normal;
    font-weight: normal;
    margin-bottom: 1em;
  }
  .reset-order {
    margin-top: 24px;
    color: #999;
    text-align: center;
  }
  .option {
    height: 48px;
    padding: 8px;
    text-align: center;
    font-size: 1.2em;
    background-color: $color-primary-light;
    flex-grow: 1;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: 4px;
  }
  .option-a {
    color: $color-text-grey;
  }

  .option-a.active {
    color: $color-primary;
  }
  .option.active {
    padding-top: 12px;
    height: 52px;
    background-color: $color-background;
    border-bottom: 0;
  }
  .card {
    position: relative;
    display: flex;
    background-color: $color-background;
    background-clip: border-box;
    border-radius: 0 .25rem;
  }
  .box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .disabled {
    color: $color-border !important;
    cursor: auto !important;
    text-decoration: none !important;
  }
  .box {
    display: flex;
    flex-wrap: nowrap;
  }
  .the-slide {
    width: 30%;
    margin-right: 24px;
    background: $color-background;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: .25rem;
    padding: 16px;
  }
  .the-content {
    width: 67%;
    flex-grow: 0;
  }
  .option {
    height: 48px;
    padding: 8px;
    text-align: center;
    font-size: 1.2em;
    background-color: $color-primary-light;
    flex-grow: 1;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: 4px;
  }
  .option-a {
    color: $color-text-grey;
  }

  .option-a.active {
    color: $color-primary;
  }
  .option.active {
    padding-top: 12px;
    height: 52px;
    background-color: $color-background;
    border-bottom: 0;
  }
  .card {
    position: relative;
    display: flex;
    background-color: $color-background;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: 0 .25rem;
  }
  .box {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .disabled {
    color: $color-border !important;
    cursor: auto !important;
    text-decoration: none !important;
  }
  .m-slide-section{
    cursor: pointer;
    padding: 10px;
    background-color: #ffffff;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  .m-slide-section:hover{
    background-color: #eeeeee;
    border: 2px solid $color-primary;
  }
  .m-slide-section:hover h4{
    color: $color-primary;
  }
  .m-slide-section-active{
    border: 2px solid $color-primary;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Videos.vue